
/// <amd-module name="Release/DeploymentsSection/Stores/SignalR" />
import { Store } from "VSS/Reflux/Store";;

import { DeploymentsSignalRActionCreator } from "Release/DeploymentsSection/Actions/SignalR";
import { ReleaseEnvironmentStatusUpdatedEvent } from "Release/Client/Contracts/Release";

export interface ISignalRStoreOptions {
    actionCreator: DeploymentsSignalRActionCreator;
}

export type EnvironmentsUpdateBatchListenerType = (environmentStatusUpdatedEvent: ReleaseEnvironmentStatusUpdatedEvent) => void;

export class SignalRStore extends Store {
    public static readonly s_maxCount = 25;

    private _actionCreator: DeploymentsSignalRActionCreator;

    private _environmentsUpdatedListeners: Array<EnvironmentsUpdateBatchListenerType> = [];

    constructor(options: ISignalRStoreOptions) {
        super("DeploymentsSignalRStoreChangedEvent");
        this._actionCreator = options.actionCreator;
        this._actionCreator.actionHub.environmentUpdated.addListener(this._onEnvironmentUpdated);
    }

    public addEnvironmentsUpdatedListener(listener: EnvironmentsUpdateBatchListenerType) {
        this._environmentsUpdatedListeners.push(listener);
    }

    public removeEnvironmentsUpdatedListener(listener: EnvironmentsUpdateBatchListenerType) {
        const index = this._environmentsUpdatedListeners.indexOf(listener);
        if (index > -1) {
            this._environmentsUpdatedListeners.splice(index, 1);
        }
    }

    public dispose() {
        this._actionCreator.actionHub.environmentUpdated.removeListener(this._onEnvironmentUpdated);
        this._environmentsUpdatedListeners = [];
    }

    private _onEnvironmentUpdated = (releaseEnvironmentStatusUpdatedEvent: ReleaseEnvironmentStatusUpdatedEvent) => {
        this._environmentsUpdatedListeners.forEach(listener => listener(releaseEnvironmentStatusUpdatedEvent));
    }
}
